import React from "react"
import { Tabs } from "antd";
import DeclarationDiff from "../../ChangeInstances/DeclarationDiff";
import ChangeHistory from "../../ChangeInstances/List/ChangeHistory";

const ChangeInstanceDetailCompact = ({ record, extraProps }: { record: Record<string, any>, extraProps: any }) => {
    const resource = extraProps.resource;

    return (
        <Tabs
            className="ci-detail-tabs"
            defaultActiveKey="diff"
            items={[
                {
                    key: 'diff',
                    label: 'Diff',
                    children: <div className="ci-diff"><DeclarationDiff change_instance={record} /></div>,
                },
                {
                    key: 'history',
                    label: 'History',
                    // same feed the change instances list shows
                    children: <ChangeHistory resource={resource} id={record.id} />,
                },
            ]}
        />
    );
}

export default ChangeInstanceDetailCompact
